import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTopLink from '../components/ScrollToTopLink';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-pink-600 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
        <ScrollToTopLink
          to="/"
          className="inline-block bg-pink-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-pink-700 transition-colors"
        >
          Go Back Home
        </ScrollToTopLink>
      </div>
    </div>
  );
};

export default NotFound; 